import * as Sentry from "@sentry/react";

// Single source of truth for the DSN and Sentry configuration.
// Browser-only: the SSR runtime (workerd) has no window/document for the
// browser tracing + replay integrations, so init is skipped there.
let initialized = false;

export function initSentry() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  Sentry.init({
    dsn: "https://725b2a2d264aa6e97dedcfe27cd94356@o4511898582319104.ingest.us.sentry.io/4511898588479488",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/portdwellr\.com/],
  });
}
